webpackJsonp([1],{

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var App = ({
  name: 'app',
  computed: extends_default()({}, Object(vuex_esm["b" /* mapGetters */])(['app', 'isAgeError', 'isNameError', 'disabled']), {
    name: {
      get: function get() {
        return this.app.name;
      },
      set: function set(value) {
        this.$store.dispatch('input', { key: 'name', value: value });
      }
    },
    age: {
      get: function get() {
        return this.app.age;
      },
      set: function set(value) {
        this.$store.dispatch('input', { key: 'age', value: value });
      }
    }
  }),
  methods: {
    clear: function clear() {
      console.log('cc', this.$store);
      // 初期化
      this.$store.commit('INIT');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd9fd6f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group",class:{'has-error': _vm.isNameError}},[_c('label',{attrs:{"for":"mmm"}},[_vm._v("Name "+_vm._s(_vm.isNameError ? 'エラー' : ''))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group",class:{'has-error': _vm.isAgeError}},[_c('label',{attrs:{"for":""}},[_vm._v("Age "+_vm._s(_vm.isAgeError ? 'エラー' : ''))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.age),expression:"age"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.age)},on:{"input":function($event){if($event.target.composing){ return; }_vm.age=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":_vm.clear}},[_vm._v("\n          Clear\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-primary",attrs:{"type":"button","disabled":_vm.disabled}},[_vm._v("\n          Submit\n        ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h1',[_vm._v("Vuex Test")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("仕様")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("名前、年齢必須")]),_vm._v(" "),_c('li',[_vm._v("名前は4文字以上")]),_vm._v(" "),_c('li',[_vm._v("年齢は数字のみ、かつ0以上")]),_vm._v(" "),_c('li',[_vm._v("名前、年齢入力済み、エラーなしの場合、Submitが押せるようになる")]),_vm._v(" "),_c('li',[_vm._v("Clearを押したらデータが初期化される")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("wMCZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/is-integer.js
var is_integer = __webpack_require__("RRo+");
var is_integer_default = /*#__PURE__*/__webpack_require__.n(is_integer);

// CONCATENATED MODULE: ./src/store/mutationsTypes.js
// 初期化
var INIT = 'INIT';
// name入力
var INPUT_NAME = 'INPUT_NAME';
// age入力
var INPUT_AGE = 'INPUT_AGE';
// CONCATENATED MODULE: ./src/store/actions.js



// actions
/* harmony default export */ var actions = ({
  // 入力
  input: function input(_ref, data) {
    var commit = _ref.commit,
        state = _ref.state;

    var value = data.value;
    // name
    if (data.key === 'name') {
      commit(INPUT_NAME, value);
    }
    // age
    if (data.key === 'age') {
      // 数字なら数字に変換する
      if (is_integer_default()(Number(value))) {
        value = Number(value);
      }
      commit(INPUT_AGE, value);
    }
  }
});
// CONCATENATED MODULE: ./src/store/getters.js

/* harmony default export */ var getters = ({
  app: function app(state) {
    return state;
  },
  // nameが未入力、または4文字未満
  isNameError: function isNameError(state) {
    var name = state.name;
    return name === '' || name.length < 4;
  },
  // ageは数字以外、または1未満
  isAgeError: function isAgeError(state) {
    var age = state.age;
    return !(is_integer_default()(age) && age > 0);
  },
  // name と ageどっちがエラー
  disabled: function disabled(state, getters) {
    return getters.isNameError || getters.isAgeError;
  }
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$INIT$types$INP;



/* harmony default export */ var mutations = (_types$INIT$types$INP = {}, defineProperty_default()(_types$INIT$types$INP, INIT, function (state) {
  state.name = '';
  state.age = null;
  state.disabled = true;
}), defineProperty_default()(_types$INIT$types$INP, INPUT_NAME, function (state, data) {
  state.name = data;
}), defineProperty_default()(_types$INIT$types$INP, INPUT_AGE, function (state, data) {
  state.age = data;
}), _types$INIT$types$INP);
// CONCATENATED MODULE: ./src/store/index.js






var store_state = {
  name: '',
  age: null
};

vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  modules: {
    app: {
      state: store_state,
      actions: actions,
      getters: getters,
      mutations: mutations
    }
  },
  strict: true
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  template: '<App/>',
  store: store,
  components: { App: src_App }
});

/***/ }),

/***/ "wMCZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.477a10c21f63b6c0028d.js